import { IAskActivity } from '@/interfaces/workflow'
import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { IApiResponse } from '@/interfaces'

const http = AttaHttpClientFactory.create(import.meta.env.VUE_APP_API_WORKFLOW)

export class WorkflowService {
	/**
	 * Retorna as atividades de ações para um determinado objeto
	 * @param objectId Objeto que deseja filtrar
	 * @returns TODO
	 */
	public static async getAskActivities(objectId: string) {
		const response = await http.get<IApiResponse<Array<IAskActivity>>>(`/askactivity`, { params: { objectId } })
		return response.data
	}

	public static async answerActivity(id: string, answer: any) {
		if (typeof answer === 'object') answer = JSON.stringify(answer)

		const response = await http.post<IApiResponse<IAskActivity>>('/askactivity', {
			id,
			metadata: {
				answer: answer
			}
		})
		return response.data
	}

	/**
	 * Retorna as informações de uma atividade especifica
	 * @param objectId
	 * @returns TODO
	 */
	public static async getAskActivity(askActivityId: string) {
		const response = await http.get<IApiResponse<IAskActivity>>(`/askactivity/activity/${askActivityId}`)
		return response.data
	}
}

export default WorkflowService
